import { render, staticRenderFns } from "./CartaoInformacoesInfraestrutura.vue?vue&type=template&id=4edc5f49&scoped=true"
import script from "./CartaoInformacoesInfraestrutura.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesInfraestrutura.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesInfraestrutura.vue?vue&type=style&index=0&id=4edc5f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc5f49",
  null
  
)

export default component.exports